export const RESOURCE_TYPE_GIC_OPTIN_STATUS = 'RESOURCE_TYPE_GIC_OPTIN_STATUS';
